export const STORE_TRAINING_PROJECTS = 'trainingProjectsStore';
export type STORE_TRAINING_PROJECTS = typeof STORE_TRAINING_PROJECTS;

export const STORE_TRAINING_PROJECT_DASHBOARD = 'trainingProjectDashboardStore';
export type STORE_TRAINING_PROJECT_DASHBOARD = typeof STORE_TRAINING_PROJECT_DASHBOARD;
